import Link from "next/link";
import React from "react";
import { connect } from "react-redux";
import { openQuickView } from "../../../redux/action/quickViewAction";
import {
  SingleContentBox,
  SingleContentImg,
  SingleContentImgWrapper,
  SingleContentTitle,
} from "./Portfolio-styles";

const PortFolioSingleProduct = ({ portfolio, openQuickView }) => {
  return (
    <>
      <SingleContentBox
        style={{ cursor: "pointer", maxHeight: "fit-content" }}
        onClick={() => openQuickView(portfolio)}
      >
        <SingleContentImgWrapper>
          <SingleContentImg src={portfolio.img_url} alt="" />
        </SingleContentImgWrapper>
        <SingleContentTitle className="d-flex flex-column align-items-center">
          <h2>
            <a onClick={openQuickView}>{portfolio.title}</a>
          </h2>
          {portfolio.img_alt}
        </SingleContentTitle>
      </SingleContentBox>
    </>
  );
};

const mapDispatchToProps = {
  openQuickView,
};

export default connect(null, mapDispatchToProps)(PortFolioSingleProduct);
